import React from 'react'
import MobLogo from './MobLogo'
import './MobSignIn.css';
import AuthForm from './AuthForm';
import Footer from '../common/Footer';
import Welcont from './Welcont';
import ForgotAuthForm from './ForgotAuthForm';
const ForgotPassMob = () => {
   

  return (
    <>
    <div className='mob-sign-out'>
        
        <MobLogo className='mob-logo'/>
        <Welcont/>
        <ForgotAuthForm className='mob-auth-form'/>
        <Footer className='mob-footer'/>
    </div>
    </>
  )
}

export default ForgotPassMob
